import React, { useEffect, useState } from "react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";

const premiumColors = [
  "#4A90E2", "#50E3C2", "#B8E986", "#F5A623", "#D0021B", "#9013FE",
  "#417505", "#F8E71C", "#7ED321", "#8B572A", "#00BCD4", "#FF4081"
];

const getCategoryColors = () => {
  const stored = localStorage.getItem("expense_category_colors");
  return stored ? JSON.parse(stored) : {};
};

const saveCategoryColors = (map) => {
  localStorage.setItem("expense_category_colors", JSON.stringify(map));
};

const ExpenseSummary = () => {
  const [chartData, setChartData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [categoryColors, setCategoryColors] = useState(getCategoryColors());
  const token = decryptToken("accessToken") || ""
  const userData = getDecryptedUserFromCookie("gta_mainstateuser");
  const url = process.env.REACT_APP_LINK;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${url}/api/expenses/all/${userData.main_id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        const data = await res.json();

        const categoryTotals = {};
        let grandTotal = 0;

        data.forEach(item => {
          const category = item.category?.trim() || "Other";
          const amount = parseFloat(item.amount) || 0;
          categoryTotals[category] = (categoryTotals[category] || 0) + amount;
          grandTotal += amount;
        });

        const updatedColors = { ...categoryColors };
        let colorIndex = 0;

        Object.keys(categoryTotals).forEach(cat => {
          if (!updatedColors[cat]) {
            updatedColors[cat] = premiumColors[colorIndex % premiumColors.length];
            colorIndex++;
          }
        });

        saveCategoryColors(updatedColors);
        setCategoryColors(updatedColors);

        const formatted = Object.entries(categoryTotals).map(([title, value]) => ({
          title,
          value,
          color: updatedColors[title] || "#ccc",
          percentage: ((value / grandTotal) * 100).toFixed(2)
        }));

        setChartData(formatted);
        setTotalAmount(grandTotal);
      } catch (err) {
        console.error("Error loading expense data", err);
      }
    };

    if (userData?.main_id) fetchData();
  }, []);

  return (
    <div className="my-4 rounded-lg shadow-md p-2 bg-white">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Expense Distribution</h3>

      {chartData.length === 0 ? (
        <p className="text-sm text-gray-500">No expense data available.</p>
      ) : (
        <>
          {/* Horizontal Bar */}
          <div className="w-full flex rounded overflow-hidden h-4 mb-3 bg-gray-200">
            {chartData.map((entry, idx) => (
              <div
                key={idx}
                className="h-full group relative"
                style={{
                  width: `${entry.percentage}%`,
                  backgroundColor: entry.color,
                }}
              >
                {/* Tooltip */}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 bg-gray-900 text-white text-xs px-3 py-1 rounded-md shadow-md transition whitespace-nowrap z-50">
                  {entry.title}: ₹{entry.value.toLocaleString("en-IN")} ({entry.percentage}%)
                </div>
              </div>
            ))}
          </div>

          {/* Total */}
          <div className="mt-2 text-sm text-gray-600 font-medium">
            Total Spent: ₹{totalAmount.toLocaleString("en-IN")}
          </div>
        </>
      )}
    </div>
  );
};

export default ExpenseSummary;
